import withLifecycles from 'async-lifecycles';
import produce from 'immer';
import React, {Component, Fragment} from 'react';
import {PortalWithState} from 'react-portal';
import WhitelistDomain from '../../store/services/whitelistDomain';
import {Header, Icon, Input, Item, Pagination, Table} from 'semantic-ui-react';
import toastr from 'toastr';
import {connect} from 'react-redux';
import {debounce} from 'lodash';

import searchImage from '../assets/search.svg';
import ConfirmButton from '../components/confirm-delete-button';
import FormContainer from '../form-components/FormContainer';
import styled from 'react-emotion';

const Styles = styled.div`
  .tableHeader {
    background-color: '#f00';
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    justify-content: space-between;

    .ui.header {
      margin-bottom: 0;
    }
  }
`;

class AllWhitelistedDomainTable extends Component {
  state = {
    loading: false,
    pageInfo: {},
    whitelistDomain: undefined,
    orderByName: false,
    activePage: 1,
  };

  _mutate = cb => {
    this.setState(produce(cb));
  };

  componentDidMount() {
    this._loadWhitelistDomains(0, '');
  }

  _deleteWhitelistDomain = async whitelistDomain => {
    try {
      await WhitelistDomain.unwhitelistDomain(whitelistDomain.id);
      toastr.info('Domain Whitelist lifted');
      this._loadWhitelistDomains(0, '');
      this.setState({searchTerm: ''});
      this._closePortal();
    } catch (error) {
      toastr.warning('Error removing whitelisted domain');
    }
  };

  _loadWhitelistDomains = (pageNumber, searchTerm) => {
    withLifecycles(
      () =>
        WhitelistDomain.fetch({
          request: {
            page: pageNumber,
            pageSize: 20,
          },
          searchTerm: searchTerm,
          orderByName: this.state.orderByName,
        }),
      ({loading, data}) => {
        this.setState({activePage: pageNumber + 1});
        this.setState(
          produce(draft => {
            draft.loading = loading;

            if (data && !data.hasErrors) {
              draft.pageInfo = data.result;
            }
          }),
        );
      },
    );
  };

  _showDetail = whitelistDomain => {
    this._openPortal();
    this.setState({whitelistDomain, error: {}});
  };

  _handleTextChanged = (event, {name, value}) => {
    this._mutate(draft => {
      draft.whitelistDomain[name] = value;
    });
  };

  render() {
    const {pageInfo, activePage} = this.state;
    const whitelistDomains = pageInfo.data || [];
    return (
      <FormContainer loading={this.state.loading}>
        <Styles>
          <div className="tableHeader">
            <Header as="h1">Whitelist Domains</Header>
            <div>
              <Input
                placeholder="Search Whitelisted Domains..."
                onChange={debounce((e, searchTerm) => {
                  this._loadWhitelistDomains(0, searchTerm.value);
                  this.setState({searchTerm: searchTerm.value});
                }, 400)}
              />
            </div>
          </div>
        </Styles>
        {pageInfo.pageCount > 0 && (
          <PortalWithState closeOnEsc>
            {({openPortal, closePortal}) => {
              this._closePortal = closePortal;
              this._openPortal = openPortal;
              return (
                <Fragment>
                  <Table basic="very" selectable>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell />

                        <Table.HeaderCell>Domain</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      {whitelistDomains.map(whitelistDomains =>
                        this._renderRow(whitelistDomains),
                      )}
                    </Table.Body>
                  </Table>
                  <Pagination
                    activePage={activePage}
                    onPageChange={async (e, paginationInfo) => {
                      await this._loadWhitelistDomains(
                        paginationInfo.activePage - 1,
                        this.state.searchTerm,
                      );
                    }}
                    ellipsisItem={{
                      content: <Icon name="ellipsis horizontal" />,
                      icon: true,
                    }}
                    firstItem={{
                      content: <Icon name="angle double left" />,
                      icon: true,
                    }}
                    lastItem={{
                      content: <Icon name="angle double right" />,
                      icon: true,
                    }}
                    prevItem={{content: <Icon name="angle left" />, icon: true}}
                    nextItem={{
                      content: <Icon name="angle right" />,
                      icon: true,
                    }}
                    totalPages={pageInfo.pageCount}
                  />
                </Fragment>
              );
            }}
          </PortalWithState>
        )}
        {whitelistDomains.length === 0 && (
          <Item.Group>
            <Item>
              <Item.Image size="mini" src={searchImage} />
              <Item.Content verticalAlign="middle">
                <strong>No Whitelisted Domains.</strong>
                <div>
                  <small>
                    No whitelist domains match your search results. Please clear
                    or refine your search.
                  </small>
                </div>
              </Item.Content>
            </Item>
          </Item.Group>
        )}
      </FormContainer>
    );
  }

  _renderRow = whitelistDomain => (
    <Table.Row key={whitelistDomain.id}>
      <Table.Cell collapsing>
        <ConfirmButton
          icon={true}
          onConfirm={() => this._deleteWhitelistDomain(whitelistDomain)}
          faIconName={'trash'}
          warningColor="#DB2828"
        />
      </Table.Cell>
      <Table.Cell>{whitelistDomain.domainName}</Table.Cell>
    </Table.Row>
  );
}

const mapStateToProps = ({customers, identity}) => ({
  customers: customers.data,
  role: identity.user.role,
});

export default connect(mapStateToProps)(AllWhitelistedDomainTable);
